import axiosInstance from "./axiosConfig";

export const createRazorpayOrder = async () => {
  const response = await axiosInstance.post("/laptops/payment/create-order");
  return response.data;
};

export const verifyPayment = async (paymentData) => {
  const response = await axiosInstance.post(
    "/laptops/payment/verify-payment",
    paymentData,
  );
  return response.data;
};

/**
 * Create Razorpay order for warranty renewal
 * POST /api/laptops/payment/create-warranty-order
 * @param {Number} renewalPrice - Price of the selected renewal plan
 */
export const createWarrantyRazorpayOrder = async (renewalPrice) => {
  const response = await axiosInstance.post(
    "/laptops/payment/create-warranty-order",
    { renewalPrice },
  );
  return response.data;
};

/**
 * Verify warranty renewal payment and update warrantyEndDate in DB
 * POST /api/laptops/payment/verify-warranty-payment
 * @param {Object} paymentData
 * @param {string} paymentData.razorpay_order_id       - From Razorpay handler response
 * @param {string} paymentData.razorpay_payment_id     - From Razorpay handler response
 * @param {string} paymentData.razorpay_signature      - From Razorpay handler response
 * @param {string} paymentData.orderId                 - Original laptop order _id
 * @param {string} paymentData.productId               - Product _id inside that order
 * @param {number} paymentData.renewalPrice            - Amount paid
 * @param {string} paymentData.newWarrantyEndDate      - ISO date string: new expiry after renewal
 */
export const verifyWarrantyPayment = async (paymentData) => {
  const response = await axiosInstance.post(
    "/laptops/payment/verify-warranty-payment",
    paymentData,
  );
  return response.data;
};
